export default {
  investScreen: {
    investCode: "Investigation Screen Code",
    investName: "Screen Name",
    columnName: "Column Logical Name",
    usageCheck: "Usage Check",
    active: "Active",
    investScreenExist: "Investigation Screen Exists"
  }
};
